import BaseComponent from '@/js/core/BaseComponent'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { MediaQ } from '@/js/constants'
import gsap from 'gsap'

gsap.registerPlugin(ScrollTrigger)

export default class PhotoStrip extends BaseComponent {
  static root = '[data-photo-strip]'

  selectors = {
    'row': '.row',
    'images[]': '.image'
  }

  setup () {
    const { $el, $els } = this
    const { row, images } = $els
    const offset = window.innerWidth > MediaQ.MD ? 20 : 10
    const diff = Math.abs(window.innerWidth - row.scrollWidth) + offset * 2
    gsap.fromTo(images
        , { x: 0 }
        , { x: -diff
          , scrollTrigger: { 
              trigger: $el, 
              scrub: 0, 
            }
        })
  }

  mounted () {
    super.mounted()
    this.setup()
    console.log('mounted')
  }
}